import { useRouter } from 'next/router';
import { useRef } from 'react';

import { useViewEvent } from 'features/events/context/ViewEvent';
import EventInfo from '../../EventInfo';
import Header from '../../../../../../components/checkout/Header';
import SpecialCode from './SpecialCode';
import CenteredContainer from 'components/CenteredContainer';
import OrderSummary from './OrderSummary';
import Tiers from './Tiers';
import { useCheckout } from 'features/events/checkout/context';
import SubmitSelectionButton from './SubmitSelectionButton';
import HorizontalNavBar from './HorizontalNavBar';
import DiscountCode from './DiscountCodeBanner';
import TopBackgroundWrapper from 'components/checkout/TopBackgroundWrapper';
import CheckoutTimer from '../../CheckoutTimer';
import { useTranslation } from 'react-i18next';

interface Props {
  showSpecialCodeForm?: boolean;
  onBack?: () => void;
  titleOverride?: string;
}

const TicketTiersContent = ({
  showSpecialCodeForm,
  onBack: onBackOverride,
  titleOverride
}: Props) => {
  const router = useRouter();
  const headerRef = useRef<HTMLDivElement>(null);
  const { event } = useViewEvent();
  const { t } = useTranslation(['checkout']);
  const { checkoutSession, tickets, appliedDiscount, user, hasTierNav } =
    useCheckout();

  const onBack = () => {
    if (onBackOverride) {
      onBackOverride();
    } else {
      router.push(`/events/${event._id}${location.search}`);
    }
  };

  return (
    <>
      <Header
        onBack={onBack}
        title={titleOverride || t('checkout:ticketsTiersTitle')}
        ref={headerRef}
        subtitle={event.title}
        isUserLoggedIn={!!user}
        TimerComponent={CheckoutTimer}
      >
        {hasTierNav && <HorizontalNavBar headerRef={headerRef} />}
      </Header>
      <TopBackgroundWrapper
        imageUrl={event.photo.url}
        hasTierNav={hasTierNav}
        isUserLoggedIn={!!user}
      >
        <>
          {checkoutSession?.checkoutError?.message &&
            (checkoutSession.isCheckoutDisabled ||
              Object.keys(tickets.selectedTicketTiers).length === 0) && (
              <div className="text-error text-center">
                {checkoutSession.checkoutError.message}
              </div>
            )}
          <div className="flex flex-1 flex-col gap-8 md:flex-row  md:items-center">
            <EventInfo />
            {showSpecialCodeForm && <SpecialCode />}
          </div>
        </>
      </TopBackgroundWrapper>
      <CenteredContainer hasPadding={false} wideContent>
        {appliedDiscount.data && (
          <div className="px-4 pt-4 md:hidden">
            <DiscountCode
              eventId={event._id}
              code={appliedDiscount.data.code}
            />
          </div>
        )}
        <div className="flex gap-8 pb-10">
          <Tiers />
          <OrderSummary />
        </div>
      </CenteredContainer>
      {(tickets.tierRequiringApproval ||
        Object.keys(tickets.selectedTicketTiers).length > 0) && (
        <div className="fixed bottom-0 left-0 right-0 bg-white px-4 pb-4 pt-2 border-neutral-200 border-t-1 md:hidden">
          <SubmitSelectionButton />
        </div>
      )}
    </>
  );
};

export default TicketTiersContent;
